import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import Message from "../animation/message/Message";
import Notification from "../animation/notification/Notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin, GetUserInfo } from "../../features/auth/Slice";
import LogoutConfirmModal from "../common-components/common_Modal/logout_Confirm_Modal/logout_Confirm_Modal";
function Header() {
  const [modalShow, setModalShow] = useState(false);
  console.log(modalShow, "modalShow");

  const handleLogout = async () => {
    Cookies.remove("pmroad_admin_security");
    navigate("/login");
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth?.user_info);

  useEffect(() => {
    dispatch(GetUserInfo());
  }, [dispatch]);

  return (
    <>
      <section className="header_main">
        <div className="container-fluid p-0">
          <div className="header_section theme_bg">
            <div className="row align-items-center me-0 ms-0">
              <div className="col-12 col-md-6">
                <div className="logo_div text-center text-md-start mb-3 mb-md-0">
                  <Link to="/">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/logo/pm-logo.png"
                      }
                      alt="logo"
                      className="logo_img img-fluid"
                      style={{ maxWidth: "180px" }}
                    />
                  </Link>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="header_content d-flex justify-content-center justify-content-md-end">
                  <div className="header_link">
                    <div className="user_info d-flex flex-column flex-md-row align-items-center gap-2 gap-md-4">
                      <div>
                        <strong
                          style={{
                            fontSize: "14px",
                            color: "#fff",
                            textAlign: "center",
                            display: "block",
                          }}
                        >
                          Admin Wallet:
                          <span style={{ color: "#fff" }}>
                            {" "}
                            ₹ {user?.rechargeAmount || 0}/-
                          </span>
                        </strong>
                      </div>

                      <div
                        className="username"
                        onClick={() => setModalShow(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <p
                          className="mb-0"
                          style={{
                            color: "#fff",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          <FontAwesomeIcon icon={faRightFromBracket} />
                          &nbsp;&nbsp;Logout
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <LogoutConfirmModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleLogout={handleLogout}
      />
    </>
  );
}

export default Header;
